import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import StripeProvider from "./components/StripeProvider";
import { CartProvider } from "./context/CartContext";
import { QuickViewProvider } from "./context/QuickViewContext";
import { CompareProvider } from "./context/CompareContext";
import { WishlistProvider } from "./context/WishlistContext";
import CartSidebar from "./components/CartSidebar";
import CompareModal from "./components/CompareModal";
import CompareBar from "./components/CompareBar";
import LogoIntro from "./components/LogoIntro";
import PageTransition from "./components/PageTransition";
import { Suspense, useState } from "react";

function App() {
  const [introDone, setIntroDone] = useState(false);

  return (
    <I18nextProvider i18n={i18n}>
      <StripeProvider>
        <CartProvider>
          <QuickViewProvider>
            <CompareProvider>
              <WishlistProvider>
                {!introDone && (
                  <LogoIntro onComplete={() => setIntroDone(true)} />
                )}
                <BrowserRouter basename={__BASE_PATH__}>
                  <PageTransition />
                  <Suspense fallback={
                    <div className="min-h-screen bg-stone-950 flex items-center justify-center">
                      <div className="w-8 h-8 border-2 border-amber-500 border-t-transparent rounded-full animate-spin"></div>
                    </div>
                  }>
                    <AppRoutes />
                  </Suspense>
                  <CartSidebar />
                  <CompareModal />
                  <CompareBar />
                </BrowserRouter>
              </WishlistProvider>
            </CompareProvider>
          </QuickViewProvider>
        </CartProvider>
      </StripeProvider>
    </I18nextProvider>
  );
}

export default App;
